import { render } from "./psico-history.vue?vue&type=template&id=c81a6d36&scoped=true"
import script from "./psico-history.vue?vue&type=script&lang=js"
export * from "./psico-history.vue?vue&type=script&lang=js"

import "./psico-history.vue?vue&type=style&index=0&id=c81a6d36&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c81a6d36"]])

export default __exports__